import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllSectorsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllSectors implements GetAllSectorsUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllSectorsUseCaseInterface.Params,
  ): Promise<GetAllSectorsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: generateUrl(`${this.url}`, params),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
